export default ({ nuxtState }, inject) => {
    inject('globalData', nuxtState.globalData)
    inject('navigationData', nuxtState.navigationData)
}
